export enum PageType {
  Portfolio = "portfolio",
  Dashboard = "dashboard",
}
